import { createActorContext } from "@xstate/react";
import { authMachine } from "../lib/authMachine";
import type { PropsWithChildren } from "react";

export const AuthContext = createActorContext(authMachine);

export function AuthProvider({ children }: PropsWithChildren) {
  return <AuthContext.Provider>{children}</AuthContext.Provider>;
}
